// extracted by mini-css-extract-plugin
export default {"icon":"StakeLink_icon_utNAk","label":"StakeLink_label_LKJIA","button":"StakeLink_button_PrYam","isActive":"StakeLink_isActive_FcnDJ"};